import React, { useState } from "react";
import Autocomplete from "react-autocomplete";
import RecipeSuggestions from "../components/RecipeSuggestions";
import { allIngredients } from "../data/ingredients";
import filter from "../util/filter";
import { Storage } from "../util/storage";

const db = new Storage("ingredients");

const menuStyle = {
	borderRadius: "3px",
	boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
	background: "rgba(255, 255, 255, 0.9)",
	padding: "2px 0",
	fontSize: "90%",
	position: "fixed",
	overflow: "auto",
	maxHeight: "50%", // TODO: don't cheat, let it flow to the bottom
};

export default function Suggestions() {
	const [searchText, setSearchText] = useState("");
	const [ingredients, setIngredients] = useState(db.getAllItems());
	let hits = [];

	if (searchText) {
		const needle = searchText.toLowerCase();
		hits = [
			...filter(
				allIngredients,
				(el) => el?.key?.toLowerCase().includes(needle),
				10
			),
		];
	}

	const addIngredient = ({ key }) => {
		const newIngredients = db.addItem(key);
		setIngredients(newIngredients);
		setSearchText("");
	};

	const removeIngredient = (ingredient) => {
		const newIngredients = db.removeItem(ingredient);
		setIngredients(newIngredients);
	};

	return (
		<div className="section">
			<div className="columns">
				<section className="column is-one-half">
					<div style={{ position: "sticky", top: 100 }}>
						<h3 className="title is-3">Ingredients</h3>
						<div className="field">
							<div className="control has-icons-left has-icons-right">
								<Autocomplete
									inputProps={{
										className: "input",
										placeholder: "Search ingredients",
									}}
									getItemValue={(item) => item.key}
									items={hits}
									menuStyle={{ ...menuStyle, zIndex: 999 }}
									renderItem={(item, highlighted) => (
										// eslint-disable-next-line jsx-a11y/anchor-is-valid
										<a
											className={`dropdown-item ${
												highlighted ? "is-active" : ""
											}`}
											key={item.key}>
											{item.key} <small>({item.n} recipes)</small>
										</a>
									)}
									value={searchText}
									onChange={(e) => setSearchText(e.target.value)}
									onSelect={(e, item) => addIngredient(item)}
								/>
								<span className="icon is-left">
									<i className="fas	fa-search" aria-hidden="true"></i>
								</span>
							</div>
						</div>
						<div className="tags">
							{ingredients.map((el, i) => (
								<div className="tag is-primary" key={i}>
									{el}
									<button
										className="delete is-small"
										type="button"
										onClick={() => removeIngredient(el)}></button>
								</div>
							))}
						</div>
					</div>
				</section>
				<section className="column is-one-half">
				<h3 className="title is-3">Suggestions</h3>
					<RecipeSuggestions />
				</section>
			</div>
		</div>
	);
}
